import React, { useState } from 'react';
import { Button } from '../ui/Button';
interface LeadCaptureFormProps {
  onSubmit: (data: {
    firstName: string;
    email: string;
  }) => void;
}
export function LeadCaptureForm({
  onSubmit
}: LeadCaptureFormProps) {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('Email is required');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    setError('');
    onSubmit({
      firstName,
      email
    });
  };
  return <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto" data-id="element-82">
      <div className="bg-crown-surface border border-crown-border rounded-lg p-6 sm:p-8 space-y-6" data-id="element-83">
        <h2 className="text-2xl md:text-3xl font-bold text-crown-text" data-id="element-84">
          Where should we send your Hair Retention Score and custom non-hormonal
          protocol?
        </h2>

        <div className="space-y-4" data-id="element-85">
          <div data-id="element-86">
            <label htmlFor="firstName" className="block text-sm font-medium text-crown-body mb-2" data-id="element-87">
              First Name <span className="text-crown-muted" data-id="element-88">(optional)</span>
            </label>
            <input type="text" id="firstName" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full px-4 py-3 bg-crown-bg border border-crown-border rounded-lg text-crown-text placeholder-crown-muted focus:outline-none focus:ring-2 focus:ring-crown-red focus:border-transparent" placeholder="John" data-id="element-89" />
          </div>

          <div data-id="element-90">
            <label htmlFor="email" className="block text-sm font-medium text-crown-body mb-2" data-id="element-91">
              Email <span className="text-crown-red" data-id="element-92">*</span>
            </label>
            <input type="email" id="email" value={email} onChange={e => {
            setEmail(e.target.value);
            setError('');
          }} className="w-full px-4 py-3 bg-crown-bg border border-crown-border rounded-lg text-crown-text placeholder-crown-muted focus:outline-none focus:ring-2 focus:ring-crown-red focus:border-transparent" placeholder="john@example.com" required data-id="element-93" />
            {error && <p className="mt-2 text-sm text-crown-red" data-id="element-94">{error}</p>}
          </div>
        </div>

        <p className="text-xs text-crown-muted leading-relaxed" data-id="element-95">
          By entering your email, you agree to receive your results and
          occasional hair-health tips from CrownControl™. You can unsubscribe
          anytime.
        </p>

        <Button type="submit" size="lg" className="w-full" data-id="element-96">
          Get My Results
        </Button>
      </div>
    </form>;
}